/* eslint-disable global-require */
/* eslint-disable import/no-unresolved */
const processInclude = require('base/util');
const quickView = require('./product/quickView');

$(document).ready(() => {
    processInclude(quickView);
});
